import { CHCMachineReadableFiles } from './machine-readable-files.component.js';
export { CHCMachineReadableFiles };

customElements.define('chcapp-machine-readable-files', CHCMachineReadableFiles);

declare global {
  interface HTMLElementTagNameMap {
    'chcapp-machine-readable-files': CHCMachineReadableFiles;
  }
}
